export default __webpack_public_path__ + "static/media/toyota.69fc99c1.svg";